import {formatNumber, recaptchaExecute} from "./dtaUtils.js";
import {dtaBoostrap} from "./dtaBoostrap.js";
import {gid} from './dtaRequest.js'
import {dateHelper} from "./dateHelper.js";

export const postProduct = {
    currency: '',
    fareharbor: false,
    bifa: false,
    hidepickdrop: false,
    departGroup: 0,
    renderAlertInfo(items, isOutsideBox = false) {
        let flatItems = [];
        if (Array.isArray(items)) {
            items.forEach(item => {
                if (Array.isArray(item)) {
                    flatItems = flatItems.concat(item);
                } else {
                    flatItems.push(item);
                }
            });
        }
        const itemWithGroup = flatItems.find(item => (item.depart_group || 0) > 1);
        if (itemWithGroup) {
            const minParticipants = itemWithGroup.depart_group || 0;
            const alertClass = isOutsideBox ? 'alert alert-warning text-dark' : 'alert alert-warning mb-0 border-0 rounded-0 text-dark';

            return `
                <div class="${alertClass}" role="alert">
                    <strong>Mininum Participants</strong>
                    <br>
                    <small>
                    A minimum total of <strong>${minParticipants}</strong> participants is required for each selected departure date. If your booking is for fewer than <strong>${minParticipants}</strong> people, we will combine it with other participants to meet the quota.
                    <br><br>
                    In the event that there are still fewer than <strong>${minParticipants}</strong> participants on the departure day, we will offer you the following options: paying a surcharge, rescheduling to another date, or canceling the booking at no extra charge.
                    </small>
                </div>
            `;
        }
        return '';
    },
    setPriceItems(extraParams, strDate) {
        const items = extraParams.productPrices[strDate].items.product;
        postProduct.currency = extraParams.productPrices[strDate].items.currency;
        postProduct.fareharbor = extraParams.productPrices[strDate].items.fareharbor || false;
        postProduct.bifa = extraParams.productPrices[strDate].items.bifa || false;
        postProduct.hidepickdrop = extraParams.productPrices[strDate].items.hidepickdrop || false;
        postProduct.departGroup = extraParams.productPrices[strDate].items.departGroup || 0;

        const elStrPickup = !postProduct.hidepickdrop ? postProduct.elLocation(extraParams.productPrices[strDate].items.pickup, 'Pickup Location', 'pickup-location') : '';
        const elStrDropOff = !postProduct.hidepickdrop ? postProduct.elLocation(extraParams.productPrices[strDate].items.dropOff, 'Drop Off Location', 'dropoff-location') : '';
        const elStrAddons = postProduct.elAddons(extraParams.productPrices[strDate].items.addons);
        const elementAddons = document.querySelector((dtaBoostrap.isColumnMd() || dtaBoostrap.isColumnSm() ? '.addons.right-column' : '.addons.left-column'));
        const elementLower = document.querySelector('strong.lower-price');
        const elements = document.querySelector('.price-list');
        const elementVehicles = document.querySelector((dtaBoostrap.isColumnMd() || dtaBoostrap.isColumnSm() ? '.addons.right-price-list' : '.addons.left-price-list'));

        if(document.querySelector('.left-price-list')) {
            document.querySelector('.left-price-list').innerHTML = '';
        }

        if(document.querySelector('.right-price-list')) {
            document.querySelector('.right-price-list').innerHTML = '';
        }

        if(document.querySelector('.addons.left-column')) {
            document.querySelector('.addons.left-column').innerHTML = '';
        }

        if(document.querySelector('.addons.right-column')) {
            document.querySelector('.addons.right-column').innerHTML = '';
        }

        if(elementLower) {
            if(extraParams.productPrices[strDate].items.lower > 0) {
                elementLower.innerHTML = postProduct.currency + ' ' + formatNumber(extraParams.productPrices[strDate].items.lower, (postProduct.currency.trim().toLowerCase()==='rp'?'id-ID':'en-US'));
                elementLower.parentElement.classList.remove('d-none');
            } else {
                elementLower.parentElement.classList.add('d-none');
            }
        }

        if(elements) {
            elements.innerHTML = '';

            if(postProduct.departGroup >= 2) {
                elements.insertAdjacentHTML('afterbegin', postProduct.renderAlertInfo(items, true));
            }

            if(Array.isArray(items)) {
                const seaterGroups = [];
                const nonSeaterGroups = [];

                items.forEach(subItems => {
                    if(Array.isArray(subItems) && subItems.length > 0) {
                        const isSeater = subItems.some(item => (item.field_name || '').toLowerCase() === 'seater');
                        if (isSeater) {
                            seaterGroups.push(subItems);
                        } else {
                            nonSeaterGroups.push(subItems);
                        }
                    }
                });

                if (seaterGroups.length > 0) {
                    const seaterTable = postProduct.getPriceTableSeater(seaterGroups, strDate);
                    if (seaterTable) {
                        elements.appendChild(seaterTable);
                    }
                }

                if (nonSeaterGroups.length > 0) {
                    nonSeaterGroups.forEach(subItems => {
                        const priceCard = postProduct.getPriceCard(subItems);
                        if(priceCard) {
                            elements.appendChild(priceCard);
                        }
                    });
                }
            }
            postProduct.setListenersButtonBook(items, elements, strDate);
        }

        if(elementVehicles) {
            elementVehicles.classList.remove('mb-4');
            elementVehicles.classList.remove('mb-3');
            elementVehicles.innerHTML = '';
            if(Array.isArray(items)) {
                if(items.length > 0) {
                    if(!dtaBoostrap.isColumnMd() && !dtaBoostrap.isColumnSm()) {
                        elementVehicles.classList.add('mb-4');
                        elementVehicles.innerHTML = '<h4>Services</h4>';
                    } else {
                        elementVehicles.classList.add('mb-3');
                    }
                    elementVehicles.appendChild(postProduct.getPriceVehicles(items));
                }
            }
            postProduct.setListenersButtonBook(items, elementVehicles, strDate);
        }

        if(elementAddons) {
            const elPriceAddons = document.createElement('div');
            if(elStrPickup || elStrDropOff) {
                const elTabList = document.createElement('div');
                elTabList.classList.add('accordion_2');
                elTabList.setAttribute('role', 'tablist');
                elTabList.innerHTML = elStrPickup + elStrDropOff;
                elPriceAddons.appendChild(elTabList);
            }

            if(elStrAddons) {
                const elAddonList = document.createElement('div');
                elAddonList.classList.add('addon-list');
                elAddonList.innerHTML = elStrAddons;
                elPriceAddons.appendChild(elAddonList);
            }

            if(elStrPickup || elStrDropOff || elStrAddons) {
                elPriceAddons.classList.add('price-addons');
                elementAddons.innerHTML = '<h4>Add-Ons</h4>';
                elementAddons.appendChild(elPriceAddons);
            }
        }
    },

    setListenersButtonBook(items, elements, strDate) {
        elements.querySelectorAll('button.btn-book').forEach(button => {
            button.addEventListener('click', async event => {
                const groupId = event.currentTarget.dataset.groupId;
                const bookUrl = event.currentTarget.dataset.bookUrl || '';
                const qty = event.currentTarget.dataset.qty || '';
                const basePath = (bookUrl || (window.location.origin + window.location.pathname)).replace(/\/+$/, '');

                if (qty) {
                    try {
                        sessionStorage.setItem('booking_initial_pax', qty);
                    } catch (e) {}
                }

                let targetUrl = basePath + `/booking/${groupId}/` + dateHelper.formatDate(strDate, 'YYYYMMDD');
                if (qty) {
                    targetUrl += `?qty=${qty}`;
                }
                window.location.href = targetUrl;
            });
        });
    },

    elLocation(items, title, elementId) {
        let strHtml = '';
        const setItemLocation = (_item) => {
            const serviceInfo = () => {
                const _time = (_item.time || '') ? `<span class="clock">${_item.time}</span>` : '';
                const _mapLatLong = (_item.latitude || '') && (_item.longitude || '') ? `<span class="meet-point"><a href="https://www.google.com/maps/search/?api=1&query=${_item.latitude},${_item.longitude}" target="_blank">Meeting Point (click)</a></span>` : '';
                const _meetPoint = (_item.url_map || '') ? `<span class="meet-point"><a href="${_item.url_map}" target="_blank">Meeting Point (click)</a></span>` : (_mapLatLong);

                if(_time || _meetPoint) {
                    return `
                        <div class="service-info">
                            ${_time}
                            ${_meetPoint}
                        </div>
                    `;
                }

                return '';
            }
            return `
                <div class="price-header bg-white">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex flex-column justify-content-center left">
                            <div><h6 class="card-title mb-0">${_item.name}</h6></div>
                            ${postProduct.getNotePriceType(_item, 'note')}
                            ${serviceInfo()}
                        </div>
                        <div class="d-flex flex-column justify-content-center right">
                            ${postProduct.getEarlyBird(_item)}
                            ${postProduct.getPrice(_item)}
                        </div>
                    </div>
                    ${postProduct.getNotePriceType(_item, 'notes', false, 'addon-notes')}
                </div>
            `;
        }

        if(Array.isArray(items)) {
            if(items.length > 0) {
                items.forEach(item => {
                    strHtml += setItemLocation(item);
                })

                return `
                    <div class="card border rounded shadow-sm mb-3 ${elementId}">
                        <div class="card-header" role="tab">
                            <h5 class="mb-0">
                                <a data-bs-toggle="collapse" href="#${elementId}Addon" aria-expanded="true">
                                    <i class="indicator ti-minus"></i>
                                    <span class="text-dark">${title}</span>
                                </a>
                            </h5>
                        </div>
                        <div id="${elementId}Addon" class="collapse show" role="tabpanel" data-bs-parent="#${elementId}Addon">
                            <div class="card-body">
                                ${ strHtml }
                            </div>
                        </div>
                    </div>
                `;
            }
        }

        return strHtml;
    },

    elAddons(items) {
        let strHtml = '';
        let strHtmlCollapsed = '';
        const addonTextInside = (text) => {
            if(text) {
                return `<div class="card-paragraph"><div class="body-paragraph">${text}</div></div>`;
            }
            return '';
        }

        const addonTextOutside = (text) => {
            if(text) {
                return `<div class="body-paragraph mb-3">${text}</div>`;
            }
            return '';
        }

        const addonGuestsOutside = (_list) => {
            let _strHtml = '';
            if(_list.addon_key=== 'Guests') {
                _list.data.forEach(_items => {
                    if(Array.isArray(_items) && _items.length > 0 && _items[0]) {
                        _strHtml += `
                            <div class="price-header">
                                <h6 class="card-title mb-0">${_items[0].name}</h6>
                                ${postProduct.getNotePriceType(_items[0], 'note', true)}
                                ${postProduct.getNotePriceType(_items[0], 'notes', true, 'addon-notes')}
                            </div>
                            <div class="price-group">
                        `;
                        _items.forEach(_item => {
                            _strHtml += `
                                <div class="d-flex justify-content-between align-items-center price-box">
                                    <div class="d-flex flex-column justify-content-center left">
                                        <div><span class="${postProduct.getIconClassPax(_item)}">${postProduct.getQuantity(_item) + postProduct.getLabelPriceType(_item)}</span></div>
                                        ${postProduct.getNotePriceType(_item, 'note')}
                                    </div>
                                    <div class="d-flex flex-column justify-content-center right">
                                        ${postProduct.getEarlyBird(_item)}
                                        ${postProduct.getPrice(_item)}
                                    </div>
                                </div>
                            `;
                        });
                        _strHtml += `</div>`;
                    }
                });
            }
            return _strHtml;
        }

        const addonOtherOutside = (_list) => {
            let _strHtml = '';
            const serviceInfo = (_item) => {
                const _quantity = postProduct.getQuantity(_item) ? `<span class="qty">${postProduct.getQuantity(_item)}(Qty.)</span>` : '';
                const _time = (_item.hour_start || _item.hour_last) ? `<span class="clock">${(_item.hour_start || '') + ((_item.hour_start || '') && (_item.hour_last || '')?'-':'') + (_item.hour_last || '')}</span>` : '';
                const _meetPoint = (_item.latitude || '') && (_item.longitude || '') ? `<span class="meet-point"><a href="https://www.google.com/maps/search/?api=1&query=${_item.latitude},${_item.longitude}" target="_blank">Meeting Point (click)</a></span>` : '';
                const _duration = (!isNaN(parseInt(_item.duration || '')) &&  parseInt(_item.duration || '') > 0) ? `<span class="duration">${_item.duration} ${_item.duration_type + ((_item.duration_type!=='v.v (oneway)' && parseInt(_item.duration || '')>1)? 's' : '')} (Duration)</span>` : '';

                if(_quantity || _meetPoint || _duration || _time) {
                    return `
                        <div class="service-info">
                            ${_quantity}
                            ${_duration}
                            ${_time}
                            ${_meetPoint}
                        </div>
                    `;
                }

                return '';
            }


            if(_list.addon_key !== 'Guests') {
                _list.data.forEach(_items => {
                    if(Array.isArray(_items) && _items.length > 0 && _items[0]) {
                        _items.forEach(_item => {
                            _strHtml += `
                                <div class="price-header bg-white">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div class="d-flex flex-column justify-content-center left">
                                            <div><h6 class="card-title mb-0">${postProduct.getLabelPriceType(_item)}</h6></div>
                                            ${postProduct.getNotePriceType(_item, 'note')}
                                            ${serviceInfo(_item)}
                                        </div>
                                        <div class="d-flex flex-column justify-content-center right">
                                            ${postProduct.getEarlyBird(_item)}
                                            ${postProduct.getPrice(_item, (_list.addon_key === 'Vehicles'?'Unit':'Service'))}
                                        </div>
                                    </div>
                                    ${postProduct.getNotePriceType(_items[0], 'notes', true, 'addon-notes')}
                                </div>
                            `;
                        });
                    }
                });
            }
            return _strHtml;
        }

        if(Array.isArray(items)) {
            if(items.length > 0) {
                items.forEach((addon, addonIndex) => {
                    if(addon.label) {
                        (addon.list || []).forEach(list => {
                            if((list.data || []).length > 0) {
                                strHtmlCollapsed += addonTextInside(list.text);
                                strHtmlCollapsed += addonGuestsOutside(list);
                                strHtmlCollapsed += addonOtherOutside(list);
                            }
                        });
                        strHtml += `
                            <div role="tablist" class="accordion_2">
                                <div class="card border rounded shadow-sm mb-3">
                                    <div class="card-header" role="tab">
                                        <h5 class="mb-0">
                                            <a data-bs-toggle="collapse" href="#collapseAddon${addonIndex}" aria-expanded="true">
                                                <i class="indicator ti-minus"></i>
                                                <span class="text-dark">${addon.label}</span>
                                            </a>
                                        </h5>
                                    </div>
                                    <div id="collapseAddon${addonIndex}" class="collapse show" role="tabpanel" data-bs-parent="#collapseAddon${addonIndex}">
                                        <div class="card-body">
                                            ${strHtmlCollapsed}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        `;
                    } else {
                        (addon.list || []).forEach(list => {
                            if((list.data || []).length > 0) {
                                strHtml += addonTextOutside(list.text);
                                strHtml += `
                                    <div class="card border rounded shadow-sm mb-3">
                                        <div class="card-body">
                                            ${addonGuestsOutside(list)}
                                            ${addonOtherOutside(list)}
                                        </div>
                                    </div>
                                `;
                            }
                        });
                    }
                });
            }
        }
        return strHtml;
    },

    getPriceCard(items) {
        if(!Array.isArray(items) || items.length === 0 || !items[0]) {
            return null;
        }

        const fhCalendar = document.querySelector('.fh-calendar');
        const template = document.createElement('div');
        let bookButton = '';

        if(!fhCalendar && !postProduct.fareharbor && postProduct.bifa) {
            bookButton = `<div class="card-footer">
                <div class="d-flex justify-content-between">
                    <div></div>
                    <div>
                        <button class="btn btn-primary btn_1_md btn-book btn-book-now" type="button" data-group-id="${items[0].group_id}" data-book-url="${items[0].book_url || ''}">Book Now</button>
                    </div>
                </div>
            </div>`;
        }

        const renderPriceHeader = ()=>{
            let _template = '';
            if(postProduct.isGrouping(items[0])) {
                _template += `
                    <div class="price-header">
                        <h5 class="card-title mb-0">${items[0].name}</h5>
                        ${postProduct.getNotePriceType(items[0], 'note', true)}
                        ${postProduct.getRoomInfo(items[0])}
                        ${postProduct.getNotePriceType(items[0], 'notes', true)}
                    </div>
                    <hr>
                `;
            }
            return _template;
        }

        const renderPriceBoxes = ()=>{
            let _template = '';
            items.forEach((item, index) => {
                _template += `
                     <div class="d-flex justify-content-between align-items-center price-box">
                        <div class="d-flex flex-column justify-content-center left">
                            <div><span class="${postProduct.getIconClassPax(item)}">${postProduct.getQuantity(item) + postProduct.getLabelPriceType(item)}</span></div>
                            ${postProduct.getNotePriceType(item, 'note')}
                        </div>
                        <div class="d-flex flex-column justify-content-center right">
                            ${postProduct.getEarlyBird(item)}
                            ${postProduct.getPrice(item)}
                        </div>
                    </div>
                    ${postProduct.getNotePriceType(item, 'notes')}
                `;
                if (index < items.length - 1) {
                    _template += '<hr>';
                }
            });
            return _template;
        }

        template.classList.add('card', 'border', 'rounded-0', 'shadow-sm', 'mb-3');
        template.innerHTML = `
            ${postProduct.departGroup <= 1 ? postProduct.renderAlertInfo(items) : ''}
            <div class="card-body">
                ${renderPriceHeader()}
                ${renderPriceBoxes()}
            </div>
            ${bookButton}
        `;
        return template;
    },

    getPriceTableSeater(seaterGroups, strDate) {
        if (!Array.isArray(seaterGroups) || seaterGroups.length === 0) {
            return null;
        }

        const flatItems = [];
        seaterGroups.forEach(group => {
            if (Array.isArray(group)) {
                group.forEach(item => {
                    if (item && (item.field_name || '').toLowerCase() === 'seater') {
                        flatItems.push(item);
                    }
                });
            } else if (group && (group.field_name || '').toLowerCase() === 'seater') {
                flatItems.push(group);
            }
        });

        if (flatItems.length === 0) {
            return null;
        }

        flatItems.sort((a, b) => {
            const minA = parseInt(a.min_qty, 10) || 0;
            const minB = parseInt(b.min_qty, 10) || 0;
            return minA - minB;
        });

        const rows = [];
        flatItems.forEach(item => {
            const minQty = parseInt(item.min_qty, 10) || 1;
            const maxQty = parseInt(item.max_qty, 10) || minQty;
            const rawPrice = (typeof item.earlybird === 'number' && item.earlybird > 0)
                ? item.earlybird
                : ((typeof item.price === 'number') ? item.price : parseFloat(item.price) || 0);

            for (let q = minQty; q <= maxQty; q++) {
                const pricePerPerson = q > 0 ? (rawPrice / q) : rawPrice;
                rows.push({
                    qty: q,
                    item: item,
                    rawPrice: rawPrice,
                    pricePerPerson: pricePerPerson
                });
            }
        });

        if (rows.length === 0) {
            return null;
        }

        const fhCalendar = document.querySelector('.fh-calendar');
        const curr = postProduct.currency ? postProduct.currency.trim() : 'A$';
        const locale = (curr.toLowerCase() === 'rp') ? 'id-ID' : 'en-US';

        let tbodyHtml = '';
        rows.forEach((row, index) => {
            const personLabel = row.qty === 1 ? '1 Person' : `${row.qty} People`;
            const roundedVal = Math.round(row.pricePerPerson);
            const formattedPrice = curr + formatNumber(roundedVal, locale);
            const isFirst = (index === 0);

            tbodyHtml += `
                <tr class="seater-row ${isFirst ? 'active-seater' : ''}" 
                    data-group-id="${row.item.group_id}" 
                    data-book-url="${row.item.book_url || ''}" 
                    data-qty="${row.qty}"
                    data-name="${row.item.name || ''}"
                    style="cursor: pointer;">
                    <td class="py-3 px-4 fw-bold text-dark border-bottom" style="font-size: 14px; width: 45%; vertical-align: middle;">
                        ${personLabel}
                    </td>
                    <td class="py-3 px-4 fw-semibold text-dark border-bottom text-end" style="font-size: 14px; text-align: right !important; width: 55%; vertical-align: middle;">
                        ${formattedPrice}
                    </td>
                </tr>
            `;
        });

        const firstRow = rows[0];
        let bookButton = '';
        if (!fhCalendar && !postProduct.fareharbor && postProduct.bifa) {
            bookButton = `
                <div class="card-footer bg-white border-top-0 d-flex justify-content-between align-items-center p-3">
                    <div class="selected-seater-desc text-muted" style="font-size: 13.5px;">
                        Selected: <strong class="text-dark seater-current-selection">${firstRow.qty === 1 ? '1 Person' : `${firstRow.qty} People`}</strong>
                    </div>
                    <div>
                        <button class="btn btn-primary btn_1_md btn-book btn-book-now" type="button" 
                                data-group-id="${firstRow.item.group_id}" 
                                data-book-url="${firstRow.item.book_url || ''}"
                                data-qty="${firstRow.qty}">
                            Book Now
                        </button>
                    </div>
                </div>
            `;
        }

        const template = document.createElement('div');
        template.classList.add('card', 'border', 'rounded-3', 'shadow-sm', 'mb-3', 'seater-table-card', 'overflow-hidden');
        template.innerHTML = `
            ${postProduct.departGroup <= 1 ? postProduct.renderAlertInfo(flatItems) : ''}
            <div class="table-responsive mb-0">
                <table class="table table-seater-pricing mb-0">
                    <thead>
                        <tr class="seater-table-header" style="background-color: #fc5b62 !important; color: #ffffff !important;">
                            <th scope="col" class="py-3 px-4 text-uppercase fw-bold border-0 text-start" 
                                style="background-color: #fc5b62 !important; color: #ffffff !important; font-size: 13.5px; letter-spacing: 0.5px; width: 45%; vertical-align: middle;">
                                NUMBER
                            </th>
                            <th scope="col" class="py-3 px-4 text-uppercase fw-bold border-0 text-end" 
                                style="background-color: #fc5b62 !important; color: #ffffff !important; font-size: 13.5px; letter-spacing: 0.5px; width: 55%; text-align: right !important; vertical-align: middle;">
                                PRICE PER PERSON
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        ${tbodyHtml}
                    </tbody>
                </table>
            </div>
            ${bookButton}
        `;

        const rowsEl = template.querySelectorAll('tr.seater-row');
        const btnBook = template.querySelector('button.btn-book-now');
        const selectionDesc = template.querySelector('.seater-current-selection');

        rowsEl.forEach(r => {
            r.addEventListener('click', () => {
                rowsEl.forEach(other => other.classList.remove('active-seater'));
                r.classList.add('active-seater');

                const gId = r.dataset.groupId;
                const bUrl = r.dataset.bookUrl || '';
                const q = r.dataset.qty;

                if (btnBook) {
                    btnBook.dataset.groupId = gId;
                    btnBook.dataset.bookUrl = bUrl;
                    btnBook.dataset.qty = q;
                }

                if (selectionDesc) {
                    selectionDesc.textContent = q === '1' ? '1 Person' : `${q} People`;
                }
            });

            r.addEventListener('dblclick', () => {
                if (btnBook) {
                    btnBook.click();
                }
            });
        });

        return template;
    },

    getPriceVehicles(items) {
        let strHtml = '';
        const fhCalendar = document.querySelector('.fh-calendar');
        const template = document.createElement('div');

        const getBookButton = (_item) => {
            if(!fhCalendar && !postProduct.fareharbor && postProduct.bifa) {
                return `<div class="flex-shrink-0 ms-3">
                    <button class="btn btn-primary btn_1_sm btn-book btn-book-now" type="button" data-group-id="${_item.group_id}" data-book-url="${_item.book_url || ''}">Book Now</button>
                </div>`;
            }
            return '';
        }

        const renderServiceInfo = (_item) => {
            const _quantity = postProduct.getQuantity(_item) ? `<span class="qty">${postProduct.getQuantity(_item)}(Qty.)</span>` : '';
            const _time = (_item.hour_start || _item.hour_last) ? `<span class="clock">${(_item.hour_start || '') + ((_item.hour_start || '') && (_item.hour_last || '')?'-':'') + (_item.hour_last || '')}</span>` : '';
            const _meetPoint = (_item.latitude || '') && (_item.longitude || '') ? `<span class="meet-point"><a href="https://www.google.com/maps/search/?api=1&query=${_item.latitude},${_item.longitude}" target="_blank">Meeting Point (click)</a></span>` : '';
            const _duration = (!isNaN(parseInt(_item.duration || '')) &&  parseInt(_item.duration || '') > 0) ? `<span class="duration">${_item.duration} ${_item.duration_type + ((_item.duration_type!=='v.v (oneway)' && parseInt(_item.duration || '')>1)? 's' : '')} (Duration)</span>` : '';

            if(_quantity || _meetPoint || _duration || _time) {
                return `
                        <div class="service-info">
                            ${_quantity}
                            ${_duration}
                            ${_time}
                            ${_meetPoint}
                        </div>
                    `;
            }

            return '';
        }

        const renderLeftPrice = (item) => {
            if(dtaBoostrap.isColumnSm()) {
                return '';
            }

            return `
                <div class="price-header bg-white">
                    <div class="d-flex justify-content-start align-items-center">
                        <div class="flex-grow-1 d-flex flex-column justify-content-center left">
                            <div><h6 class="card-title mb-0">${postProduct.getLabelPriceType(item)}</h6></div>
                            ${postProduct.getNotePriceType(item, 'note')}
                            ${renderServiceInfo(item)}
                        </div>
                        <div class="flex-shrink-0 d-flex flex-column justify-content-center right">
                            ${postProduct.getEarlyBird(item)}
                            ${postProduct.getPrice(item, 'Service')}
                        </div>
                        ${getBookButton(item)}
                    </div>
                    ${postProduct.getNotePriceType(item, 'notes', true, 'addon-notes')}
                </div>
            `;
        }

        const renderRightPrice = (item) => {
            if(!dtaBoostrap.isColumnSm()) {
                return '';
            }

            return `
                <div class="price-header bg-white">
                    <div class="flex-grow-1 d-flex flex-column justify-content-center left">
                        <div><h6 class="card-title mb-0">${postProduct.getLabelPriceType(item)}</h6></div>
                        ${postProduct.getNotePriceType(item, 'note')}
                        ${renderServiceInfo(item)}
                    </div>
                    ${postProduct.getNotePriceType(item, 'notes', true, 'addon-notes')}
                    <div class="d-flex justify-content-between align-items-center mt-1">
                        <div class="flex-shrink-0 d-flex flex-column">
                            ${postProduct.getEarlyBird(item)}
                            ${postProduct.getPrice(item, 'Service')}
                        </div>
                        ${getBookButton(item)}
                    </div>
                </div>
            `;
        }

        items.forEach(item => {
            const firstItem = Array.isArray(item) ? item[0] : item;
            if (firstItem) {
                strHtml += renderLeftPrice(firstItem);
                strHtml += renderRightPrice(firstItem);
            }
        });

        template.classList.add('price-addons');
        template.innerHTML = `
            <div class="card border rounded shadow-sm mb-3">
                <div class="card-body">${strHtml}</div>
            </div>
        `;
        return template;
    },

    isGrouping(item) {
        return (item.hasOwnProperty('guest') && item.guest && !['adult', 'child', 'infant', 'tour_leader'].includes(item.field_name));
    },

    getIconClassPax(item) {
        if(item.hasOwnProperty('field_name')) {
            if(item.field_name === 'adult') {
                return 'adult';
            } else if(item.field_name === 'child') {
                return 'child';
            } else if(item.field_name === 'infant') {
                return 'infant';
            } else if(item.field_name === 'tour_leader') {
                return 'tour_leader';
            }
        }

        if(item.hasOwnProperty('guest')) {
            if(item.guest.toLowerCase() === 'adult') {
                return 'adult';
            } else if(item.guest.toLowerCase() === 'child') {
                return 'child';
            } else if(item.guest.toLowerCase() === 'infant') {
                return 'infant';
            }
        }
        return 'other_pax';
    },

    getLabelPriceType(item) {
        if(postProduct.isGrouping(item)) {
            return item.guest;
        }
        return item.name;
    },

    getQuantity(item, isNumberOutput=false) {
        let _quantity = isNaN(parseInt(item.quantity) || 0) ? 0 : (parseInt(item.quantity) || 0);
        if (this.isGrouping(item)) {
            if(item.hasOwnProperty('guest')) {
                _quantity = isNaN(parseInt(item[`${item.guest.toLowerCase()}_qty`]) || 0) ? 0 : (parseInt(item[`${item.guest.toLowerCase()}_qty`]) || 0);
            }
        }

        if(!isNaN(_quantity) && _quantity > 0) {
            return isNumberOutput ? _quantity : (_quantity>1 ? `${_quantity} ` : '');
        }

        return isNumberOutput ? 0 : '';
    },

    getRoomInfo(item) {
        if(postProduct.isGrouping(item)) {
            if((item.room || '') || (item.bed || '')) {
                const _room = (item.room || '') ? `<div class="room mb-1">${item.room}</div>` : '';
                const _bed = (item.bed || '') ? `<div class="bed">${item.bed}</div>` : '';
                return `<div class="room-info">
                    ${_room}
                    ${_bed}
                </div>`;
            }
        }
        return '';
    },

    getNotePriceType(item, property, isHeader=false, classNotes='price-notes') {
        let _note = (item[property] || '').trim();
        if(this.isGrouping(item) && !isHeader) {
            if(item.hasOwnProperty('guest')) {
                if(item.guest.toLowerCase() === 'adult') {
                    _note = item[`adult_${property}`] || (item[`guest_${property}`] || '');
                } else if(item.guest.toLowerCase() === 'child') {
                    _note = item[`child_${property}`] || (item[`guest_${property}`] || '');
                } else if(item.guest.toLowerCase() === 'infant') {
                    _note = item[`infant_${property}`] || (item[`guest_${property}`] || '');
                }
            }
        }

        if(!_note) {
            return '';
        }

        if(property==='note') {
            return `<div><small class="note">${_note}</small></div>`;
        }

        return `<div class="notes"><div class="body-paragraph ${classNotes}">${_note}</div></div>`;
    },

    getEarlyBird (item) {
        const earlyBird = (typeof (item.earlybird || 0)) === 'number' ? (item.earlybird || 0) : (!isNaN(parseFloat(item.earlybird)) ? parseFloat(item.earlybird) : 0);
        const nonPromoPrice = (typeof (item.np_price || 0)) === 'number' ? (item.np_price || 0) : (!isNaN(parseFloat(item.np_price)) ? parseFloat(item.np_price) : 0);
        const price = (typeof (item.price || 0)) === 'number' ? (item.price || 0) : (!isNaN(parseFloat(item.price)) ? parseFloat(item.price) : 0);

        if (price > 0 && nonPromoPrice > 0) {
            const formatValue = formatNumber(nonPromoPrice, (postProduct.currency.trim().toLowerCase()==='rp'?'id-ID':'en-US'));
            if(formatValue) {
                return `<div class="text-decoration-line-through text-danger">${postProduct.currency + formatValue}</div>`;
            }
        }

        if (earlyBird > 0 && price > 0) {
            const formatValue = formatNumber(price, (postProduct.currency.trim().toLowerCase()==='rp'?'id-ID':'en-US'));
            if(formatValue) {
                return `<div class="text-decoration-line-through text-danger">${postProduct.currency + formatValue}</div>`;
            }
        }
        return '';
    },

    getPrice(item, subPriceInfo = 'pax')  {
        let formatValue;
        const earlyBird = (typeof (item.earlybird || 0)) === 'number' ? (item.earlybird || 0) : (!isNaN(parseFloat(item.earlybird)) ? parseFloat(item.earlybird) : 0);
        const nonPromoPrice = (typeof (item.np_price || 0)) === 'number' ? (item.np_price || 0) : (!isNaN(parseFloat(item.np_price)) ? parseFloat(item.np_price) : 0);
        const price = (typeof (item.price || 0)) === 'number' ? (item.price || 0) : (!isNaN(parseFloat(item.price)) ? parseFloat(item.price) : 0);
        const priceInfo = postProduct.getQuantity(item, true) >= 2 ? `<sub>/${subPriceInfo}</sub>` : '';

        if (nonPromoPrice > 0) {
            formatValue = formatNumber(price, (postProduct.currency.trim().toLowerCase()==='rp'?'id-ID':'en-US'));
            if(formatValue) {
                return `<div><strong class="fs-6">${postProduct.currency + formatValue}</strong>${priceInfo}</div>`;
            }
        }

        if (earlyBird > 0) {
            formatValue = formatNumber(earlyBird, (postProduct.currency.trim().toLowerCase()==='rp'?'id-ID':'en-US'));
            if(formatValue) {
                return `<div><strong class="fs-6">${postProduct.currency + formatValue}</strong>${priceInfo}</div>`;
            }
        }

        formatValue = formatNumber(price, (postProduct.currency.trim().toLowerCase()==='rp'?'id-ID':'en-US'));
        if(formatValue) {
            if(price===0) {
                return `<div></div>`;
            }
            return `<div><strong class="fs-6">${price===0 ? '' : postProduct.currency + formatValue}</strong>${priceInfo}</div>`;
        }
    }
}
